import { useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import { MdArrowBack, MdArrowForward, MdZoomIn, MdZoomOut } from "react-icons/md"
import ProtectedContent from "./ProtectedContent"


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();


export default function DocumentReader({ data, label, watermark }) {

  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.15);
  const [error, setError] = useState('');

  function documentLoaded({ numPages: loadedPages }) {
    setNumPages(loadedPages);
    setPageNumber(1);
    setError('');
  }

  function previousPage() {
    setPageNumber((currentPage) => Math.max(currentPage - 1, 1));
  }

  function nextPage() {
    setPageNumber((currentPage) => Math.min(currentPage + 1, numPages));
  }

  function zoomOut() {
    setScale((currentScale) => Math.max(currentScale - 0.15, 0.7));
  }

  function zoomIn() {
    setScale((currentScale) => Math.min(currentScale + 0.15, 2));
  }

  return (
    <div className="library-document-access">
      <div className="library-reader-toolbar">
        <div className="library-reader-toolbar-group">
          <button
            className="btn btn-light btn-rounded"
            disabled={pageNumber <= 1}
            onClick={previousPage}
            type="button"
          >
            <MdArrowBack /> Previous
          </button>
          <span>Page {pageNumber}{numPages > 0 ? ` of ${numPages}` : ''}</span>
          <button
            className="btn btn-light btn-rounded"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
            type="button"
          >
            Next <MdArrowForward />
          </button>
        </div>
        <div className="library-reader-toolbar-group">
          <button className="btn btn-light btn-rounded" onClick={zoomOut} type="button">
            <MdZoomOut />
          </button>
          <span>{Math.round(scale * 100)}%</span>
          <button className="btn btn-light btn-rounded" onClick={zoomIn} type="button">
            <MdZoomIn />
          </button>
        </div>
      </div>

      <ProtectedContent watermark={watermark}>
        <div className="library-pdf-reader">
          <Document
            file={data.contentUrl}
            loading={<div className="marketplace-empty-state">Loading {label}...</div>}
            onLoadError={() => setError(`Could not load this ${label}. Please reopen it from your library.`)}
            onLoadSuccess={documentLoaded}
          >
            {
              !error &&
              <Page
                canvasBackground="white"
                pageNumber={pageNumber}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                scale={scale}
              />
            }
          </Document>
          {error && <div className="marketplace-empty-state">{error}</div>}
        </div>
      </ProtectedContent>
    </div>
  )
}
